import { mdiVote } from "@mdi/js";
import Icon from "@mdi/react";
import { useContext, useEffect, useState } from "react";
import { Link, useHistory, useNavigate } from "react-router-dom";
import { ThemeContext } from "../../common/theme/ThemeContext";
import Tooltip from "../../common/tooltip/Tooltip";
import ActiveElectionsSummaryPanel from "./elections/panel/ActiveElectionsSummaryPanel";
import { GET } from "../../utils/fetchUtil";
import { MessageContext } from "../../common/message";
import { useTranslation } from "react-i18next";
import Loader from "../../common/loader/Loader";

const RequestVotingPage = () => {
  const theme = useContext(ThemeContext);
  const [elections, setElections] = useState();
  const [fetchElections, setFetchElections] = useState(1);
  const message = useContext(MessageContext);
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    GET(
      "/elections",
      (response) => {
        setElections(response);
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
            history.goBack();
          },
        });
      }
    );
  }, [fetchElections]);

  if (elections) {
    return (
      <>
        <div className="is-flex is-align-items-center is-justify-content-center is-size-4">
          <h1 className="m-0 mr-5">Elektronički</h1>
          <Icon path={mdiVote} size={2.7} className={`has-text-${theme.iconColor}`} />
          <h1 className="m-0 ml-5"> izbori</h1>
        </div>
        <div className="is-flex is-justify-content-center mt-5">
          <Tooltip delay={"0"} content={"Unos izbora"}>
            <Link
              to={"/elections/new"}
              className={`button has-text-white has-background-${theme.iconColor}`}
            >
              Prijavi izbore
            </Link>
          </Tooltip>
        </div>

        {elections.map((election, index) => {
          return (
            <ActiveElectionsSummaryPanel
              election={election}
              index={index}
              key={index}
              setFetchElections={setFetchElections}
            />
          );
        })}
      </>
    );
  } else if (elections?.length === 0) {
    return <ActiveElectionsSummaryPanel noElections={true} />;
  } else {
    return <Loader />;
  }
};

export default RequestVotingPage;
